import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BigCalendar from "react-big-calendar";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {getWarehouse} from "../../store/actions/warehouse";
import {getBooks} from "../../store/actions/book";


const calendarViews = ['month', 'day'];

class Warehouse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: calendarViews[0],
      date: new Date(),
    };
  }

  componentDidMount() {
    const id = this.props.match.params.id;

    this.props.getWarehouse(id, this.props.history);
  }

  componentWillReceiveProps(nextProps) {
    const {warehouse} = nextProps;

    if (Object.keys(warehouse).length > 0 && nextProps.books.length === 0) {
      this.props.getBooks(warehouse.id);
    }
  }

  onSelectSlot(slotInfo) {
    const {view} = this.state;

    if (view === 'month') {
      this.setState({
        view: 'day',
        date: slotInfo.slots[0]
      });
    }
  }

  handleViewChange(view) {
    this.setState({
      view
    });
  }

  handleDateChange(date) {
    this.setState({
      date
    });
  }

  getEventProps(event) {
    return {
      className: !event.responded ? 'requested' : event.user === this.props.user.id ? 'my-booking' : null
    };
  }

  convertBooksToEvents(books) {
    return books.map(book => ({
      ...book,
      id: book.id,
      title: `${book.po_number} - ${book.truck_number}`,
      start: new Date(book.start_date),
      end: new Date(book.end_date),
      resourceId: book.dock,
      user: book.user
    }));
  }

  convertDocksToResource(docks) {
    return docks.map(dock => ({
      resourceId: dock.id,
      resourceTitle: dock.name
    }));
  }

  render() {
    const {view, date} = this.state;
    const {warehouse, books} = this.props;
    const resources = this.convertDocksToResource(warehouse.warehouse_docks || []);

    let events = this.convertBooksToEvents(books);


    return (
        <main>
          <div className="container dashboard">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="card">
                  <p><Link to="/warehouses">Warehouses</Link> / {warehouse.name}</p>
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h2>Bookings for {warehouse.name}</h2>
                  </div>
                  <div className="card-body">
                    <BigCalendar
                        selectable
                        events={events}
                        resources={resources}
                        resourceIdAccessor="resourceId"
                        resourceTitleAccessor="resourceTitle"
                        views={calendarViews}
                        popup={true}
                        view={view}
                        onSelectSlot={this.onSelectSlot.bind(this)}
                        onView={this.handleViewChange.bind(this)}
                        date={date}
                        onNavigate={this.handleDateChange.bind(this)}
                        eventPropGetter={this.getEventProps.bind(this)}
                        timeslots={1}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
    );
  }
}

Warehouse.propTypes = {
  warehouse: PropTypes.object.isRequired,
  getWarehouse: PropTypes.func.isRequired,
  getBooks: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
};

Warehouse.defaultProps = {
  warehouse: {},
  books: [],
  user: {}
};

const initMapStateToProps = state => ({
  warehouse: state.warehouse.warehouse,
  books: state.book.books,
  user: state.auth.user
});

const initMapDispatchToProps = dispatch => ({
  getWarehouse: (id, history) => dispatch(getWarehouse(id, history)),
  getBooks: id => dispatch(getBooks(id))
});

export default connect(initMapStateToProps, initMapDispatchToProps)(Warehouse);



// WEBPACK FOOTER //
// ./src/containers/Warehouses/Warehouse.jsx